import React from "react";
import * as Animate from "react-reveal";
import IncubationIcon from "../../../assets/images/svg/incubation.svg";
import LearningIcon from "../../../assets/images/svg/intensive-learning.svg";
import InternshipIcon from "../../../assets/images/svg/internship.svg";

const UbnValue = ({ icon, title, description }) => {
  return (
    <div className="text-center md:text-left mb-3 md:mb-0">
      <p className=" py-2 px-2 rounded-lg w-14 lg:w-20 mx-auto md:mx-0 ">
        <img src={icon} alt="" />
      </p>

      <h4 className="text-default font-mono text-lg lg:text-xl font-semibold pt-4 pb-6">
        {title}
      </h4>

      <p className="text-default text-sm-15 lg:text-base lg:leading-7">
        {description}
      </p>
    </div>
  );
};

const UbnValueSection = ({ showImages = true }) => {
  return (
    <section className="pt-16 md:pt-16 md:pb-16 relative -top-20 bg-white md:top-0 rounded-lg">
      <div className="container mx-auto px-4">
        <div className="relative text-center mx-auto">
          <Animate.Fade bottom>
            <h3 className="text-primary font-semibold font-mono text-2xl lg:text-3xl xl:text-4xl w-10/12 lg:w-6/12 xl:w-4/12 mx-auto text-center">
              Benefits of Joining the Network
            </h3>
          </Animate.Fade>
        </div>

        <div className="pt-16 lg:pt-24 pb-12 relative w-full lg:w-11/12 xl:w-10/12 mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-12 lg:gap-16">
            <Animate.Fade bottom>
              <UbnValue
                icon={IncubationIcon}
                title="A Single Platform"
                description="Your staff members gets onboarded on our learning platform for free"
              />
              <UbnValue
                icon={LearningIcon}
                title="Networking"
                description="Privilege to connect with other folks from top companies to learn together"
              />
              <UbnValue
                icon={InternshipIcon}
                title="Insight"
                description="These classes give HR leaders the knowledge they need to design better learning programs with clear ROI."
              />
              <UbnValue
                icon={IncubationIcon}
                title="Certificate"
                description="Most of the courses also give your staff the opportunity to
                earn free certificates upon completion and performance
                Evaluations.
                "
              />
              <UbnValue
                icon={LearningIcon}
                title="Report"
                description="Each learning experience comes with a report that
                helps HR leaders make more informed decisions.
                 "
              />
            </Animate.Fade>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UbnValueSection;
